module.exports = __webpack_public_path__ + "static/aboutus-4-min-f775a93abbe7f3df700812575d1248c2.png";